__turbopack_context__.v({
  "blog-header-text-container": "PostHero-module-scss-module__tDKMGG__blog-header-text-container",
  "category-arrow": "PostHero-module-scss-module__tDKMGG__category-arrow",
  "featured-image-container": "PostHero-module-scss-module__tDKMGG__featured-image-container",
  "post-breadcrumbs": "PostHero-module-scss-module__tDKMGG__post-breadcrumbs",
  "post-hero": "PostHero-module-scss-module__tDKMGG__post-hero",
  "post-hero-grid": "PostHero-module-scss-module__tDKMGG__post-hero-grid",
});
